/* unplugin-vue-components disabled */
import $settings from 'stores/settings'
import {Tasks} from 'utils'
import {TASK_STATUS} from 'utils/tasks'
import {API_TASKS} from 'consts/api'

export default {
  props: {
    caption: {type: String, required: true},
    runnerId: {type: String, required: true},
    runner: {type: Function, required: true},
    canRun: {type: Boolean, default: true}
  },
  emits: ['run', 'end'],
  data() {
    return {
      tasks: new Tasks(),
      loading: true,
      running: false,
      task_setting: undefined,
      task_data: undefined,
    }
  },
  computed: {
    setting_id() {
      return `${this.runnerId}_task`
    },
    task_id() {
      return this.task_setting ? this.task_setting.id : undefined
    },
    task_status() {
      const status = this.task_data ? this.task_data.status : 'N/A'
      if (status === TASK_STATUS.RUNNING && this.task_data?.result?.status) {
        return `${status}, ${this.task_data.result.status}`
      }
      return status
    },
    task_date() {
      return this.task_data ? $utils.format.datetime(this.task_data.created_at) : 'N/A'
    },
    task_error() {
      return this.task_data ? this.task_data.error : undefined
    },  
    task_result() {
      return this.task_data ? this.task_data.result : undefined
    },
    task_subtasks() {
      return this.task_data ? this.task_data.subtasks : undefined
    },
    can_run() {
      return !this.loading && !this.running && this.canRun
    },
  },
  async mounted() {
    this.loading = true
    this.task_setting = await $settings.get(this.setting_id)
    this.loading = false

    this.running = true
    try {
      await this.waitTask()
    }
    catch(err) {
      // Bypass error modal popup
      console.log(err)
    }
    this.running = false
  },
  async beforeUnmount() {
    await this.tasks.cancelAll(false)
  },
  methods: {
    async waitTask() {
      if (this.task_setting) {
        try {
          this.task_data = await this.tasks.get(this.task_setting.id)
          this.task_data = await this.tasks.waitTask(this.task_setting.id, 3000, (data) => {
            if (Object.keys(data).length > 0)
              this.task_data = data
          })
        }
        catch(err) {
          if (err.http_code === 404) {
            // task might be missing if it was running long ago
            // that's ok, tasks are kept in db only for 1 month
            return
          }
          throw err
        }
      }
    },
    async onRunTask() {
      this.loading = true

      // runner can return no task
      let task_id = await this.runner(this.tasks)
      if (task_id) {
        this.task_setting = undefined
        this.task_data = undefined
        this.task_setting = {id: task_id}
        await $settings.put(this.setting_id, this.task_setting)
      }
      this.loading = false

      if (task_id) {
        this.running = true
        await this.waitTask()
        this.running = false
      }
    },
    async onRestartTask() {
      this.running = true
      await this.tasks._rest.post(`${API_TASKS}/${this.task_setting.id}/restart`, {})
      await this.waitTask()
      this.running = false
    },
    async copyError(error) {
      await $utils.copyText($utils.format.json(error))
    },
    async copyResult() {
      await $utils.copyText($utils.format.json(this.task_result))
    },
    async downloadFile() {
      await $utils.downloadFile(this.task_result.file_url)
    }
  }
}
